module.exports = __webpack_public_path__ + "img/icon_request.9d61e0ba.svg";